module.exports = __webpack_public_path__ + "media/images/administrator_profile_footer-88e46e68f680da953b85d97ccf7ba5e9.png";